import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OnboardingProgress } from "~/molecules/OnboardingProgress";
import { CreateDraftsStep } from "~/organisms/document-onboarding/CreateDraftsStep";
import { CompleteStep } from "~/organisms/document-onboarding/CompleteStep";

export default function OnboardDocuments() {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [createdVersionIds, setCreatedVersionIds] = useState<number[]>([]);
  const [isCompleted, setIsCompleted] = useState(false);

  const goToNext = () =>
    setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
  const appendCreated = (id: number) =>
    setCreatedVersionIds((prev) => [...prev, id]);
  const restart = () => {
    setCurrentStep(0);
    setCreatedVersionIds([]);
    setIsCompleted(false);
  };

  const steps = [
    {
      title: t(($) => $.library.onboardDocuments.steps.createDrafts.title),
      description: t(
        ($) => $.library.onboardDocuments.steps.createDrafts.description,
      ),
      component: (
        <CreateDraftsStep onCreated={appendCreated} onNext={goToNext} />
      ),
    },
    {
      title: t(
        ($) => $.library.onboardDocuments.steps.configureAndPublish.title,
      ),
      description: t(
        ($) => $.library.onboardDocuments.steps.configureAndPublish.description,
      ),
      component: (
        <CompleteStep
          createdVersionIds={createdVersionIds}
          isCompleted={isCompleted}
          onComplete={() => setIsCompleted(true)}
          onRestart={restart}
        />
      ),
    },
  ];

  return (
    <div className="container flex flex-col gap-8 py-8">
      <div className="flex flex-col items-center gap-2 text-center">
        <h1 className="text-3xl font-bold">
          {t(($) => $.library.onboardDocuments.header)}
        </h1>
        <p className="text-muted-foreground max-w-2xl">
          {t(($) => $.library.onboardDocuments.subtitle)}
        </p>
      </div>
      <OnboardingProgress
        currentIndex={isCompleted ? steps.length : currentStep}
        steps={steps}
      />
      {steps[currentStep]?.component}
    </div>
  );
}
